import { createContext, useContext, useState } from 'react';

const QuizContext = createContext(null);

export const QuizProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [questions, setQuestions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setAnswer = (questionId, answer) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const nextStep = () => {
    if (currentStep < questions.length - 1) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const resetQuiz = () => {
    setCurrentStep(0);
    setAnswers({});
    setIsSubmitting(false);
  };

  const getFormattedAnswers = () => {
    return Object.entries(answers).map(([question_id, answer]) => ({
      question_id,
      answer
    }));
  };

  const progress = questions.length > 0 ? ((currentStep + 1) / questions.length) * 100 : 0;

  return (
    <QuizContext.Provider value={{
      currentStep,
      setCurrentStep,
      answers,
      setAnswer,
      questions,
      setQuestions,
      nextStep,
      prevStep,
      resetQuiz,
      getFormattedAnswers,
      progress,
      isSubmitting,
      setIsSubmitting
    }}>
      {children}
    </QuizContext.Provider>
  );
};

export const useQuiz = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuiz must be used within a QuizProvider');
  }
  return context;
};
